import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import { API } from "../App";

// Checks whose job can be re-run from the health banner.
export const RERUNNABLE = { theme_runs: "theme formation" };

export const HealthRerunButton = ({ checkId, token, onDone }) => {
  const [state, setState] = useState("idle");
  const [error, setError] = useState(null);
  const timer = useRef(null);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => () => clearInterval(timer.current), []);

  const poll = () => {
    timer.current = setInterval(async () => {
      const s = await fetch(`${API}/themes/status`, { headers }).then((r) => r.json()).catch(() => null);
      if (!s || s.running) return;
      clearInterval(timer.current);
      if (s.error) {
        setError(s.error);
        setState("failed");
      } else {
        setState("done");
        onDone();
      }
    }, 5000);
  };

  const start = async () => {
    setState("running");
    setError(null);
    const r = await fetch(`${API}/pipeline/rerun/${checkId}`, { method: "POST", headers }).catch(() => null);
    if (!r || !r.ok) {
      setState("failed");
      setError("could not start");
      return;
    }
    poll();
  };

  const label = { idle: "Run now", running: "Running…", done: "Done", failed: "Retry" }[state];
  return (
    <span className="inline-flex items-center gap-2 ml-2">
      <button
        data-testid={`health-rerun-${checkId}`}
        onClick={start}
        disabled={state === "running" || state === "done"}
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm border border-current/40 hover:bg-white/10 disabled:opacity-60 transition-colors"
      >
        <RefreshCw className={`w-3 h-3 ${state === "running" ? "animate-spin" : ""}`} />
        {label}
      </button>
      {error && (
        <span data-testid={`health-rerun-error-${checkId}`} className="opacity-80">
          failed: {String(error).slice(0, 120)}
        </span>
      )}
    </span>
  );
};
